import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { allowedLanguages } from '../../constants/Translation';

const DEFAULT_VALUE = '__DEFAULT__';

interface LanguageDropdownProps {
  label?: string;
  defaultOptionLabel?: string;
  value: string | null;
  onChange: (newValue: string | null) => void;
  allowDefault?: boolean;
}

export const LanguageDropdown = (props: LanguageDropdownProps) => {
  return (
    <FormControl size='small' fullWidth>
      {!!props.label && <InputLabel>{props.label}</InputLabel>}

      <Select
        label={props.label}
        value={props.value || DEFAULT_VALUE}
        onChange={(e) =>
          props.onChange(
            e.target.value === DEFAULT_VALUE ? null : e.target.value,
          )
        }
      >
        {(props.allowDefault || !props.value) && (
          <MenuItem key={DEFAULT_VALUE} value={DEFAULT_VALUE}>
            {props.defaultOptionLabel ?? 'Varsayılan'}
          </MenuItem>
        )}

        {allowedLanguages.map((lang) => (
          <MenuItem key={lang.locale} value={lang.locale}>
            {lang.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
